import { ReactNode, forwardRef } from 'react';
import { Radio, Text, RadioProps } from 'theme-ui';
import { titleize } from 'inflected';

interface RadioOptionProps extends RadioProps {
  label?: ReactNode;
}

const RadioOption = forwardRef<HTMLInputElement, RadioOptionProps>(({ className, label, ...props }: RadioOptionProps, ref) => {
  return (
    <label
      className={className}
      sx={{
        display: 'inline-flex',
        alignItems: 'center'
      }}>
      <Radio
        ref={ref}
        sx={{ mr: 1 }}
        {...props}
      />
      {label || <Text>{titleize(props.value as string)}</Text>}
    </label>
  )
});

export default RadioOption;
